import trackingService from "../../../advanced-search/services/tracking/advancedSearchTrackingService";
import type { TitlesSelectionProps } from "../TitlesSelection/TitlesSelection";
import TitlesSelection from "../TitlesSelection/TitlesSelection";

type IncludedTitlesProps = Pick<TitlesSelectionProps, "selectedItems" | "id" | "isReadOnly"> & {
    onChange(titles: string[]): void;
};

const IncludedTitles = ({ onChange, ...rest }: IncludedTitlesProps) => {
    function handleAdd(title: string) {
        trackingService.contactsFilters.trackProfileTitleAddedToInclude(title);
        onChange(rest.selectedItems.concat(title));
    }

    function handleRemove(title: string) {
        trackingService.contactsFilters.trackProfileTitleRemovedFromInclude(title);
        onChange(rest.selectedItems.filter((t) => t !== title));
    }

    return (
        <TitlesSelection
            {...rest}
            onAdd={handleAdd}
            onRemove={handleRemove}
            label={{ key: "si.contacts-search-profiles.label.include" }}
        />
    );
}

export default IncludedTitles;
